// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"80979ca9","455":"ee5185ca","977":"07c2478d"}[chunkId] + ".chunk.js";
};